import React, { useState, useEffect, useRef } from "react";
import { HideLoder, ShowLoder, compressImage, getAllBuildings, isValidEmail } from "../../JS/Common";
import { CheckValidation, ValidateFile } from "../../Components/Validations";
import { ApiCmnHeadersPostCall, ApiGetCallAuthKey } from "../../JS/Connector";
import AlertsComp from "../../Components/AlertsComp";
import ReCAPTCHA from "react-google-recaptcha";
import VideoUpload from "./VideoUpload";
import { GoogleLoginForSupportTicket } from "../Signin/GoogleLoginForSupportTicket";
import { MicrosoftLoginForSupportTicket } from "../Signin/MicrosoftLoginForSupportTicket";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";

export function TicketForm() {
    const { manager_user, staff_member, user_no, third_party_page_logo, ticket_form_context_question } = useConfig();
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const schoolnumber = pathArray[2];
    const [loading, setLoading] = useState(false);
    const [schoolname, setschoolname] = useState("");
    const [Alerts, setAlerts] = useState("");
    const [schoolid, setschoolid] = useState("");
    const [EmailValidation, setEmailValidation] = useState("");
    const [TechMainData, setTechMainData] = useState([]);
    const [Buildings, setBuildings] = useState([]);
    const [TechMaintenceSelected, setTechMaintenceSelected] = useState('');
    const [TachDetails, setTachDetails] = useState({
        typeflag: 1,
        Showoption: '',
        OtherFields: 'd-none'
    })
    var captchasitekey = process.env.REACT_APP_Captcha_Sitekey;
    const [allData, setallData] = useState({
        title: "",
        name: "",
        email: "",
        building: "",
        roomno: "",
        Document: null,
        Filename: "",
        Description: "",
        Flag: 2,
        StudentNumber: '',
        Buildingname: '',
        loginToken: '',
        roomname: ''
    })
    const [isCheckedForOther, setIsCheckedForOther] = useState(false);
    const [Video, setVideo] = useState('');
    const [LoginFlag, setLoginFlag] = useState(2);
    const [GoogleMicrosoftFlag, setGoogleMicrosoftFlag] = useState('');
    const [BuildingValidation, setBuildingValidation] = useState("");
    const [RoomData, setRoomData] = useState([]);
    const [error, setError] = useState('');
    const StateData = useSelector((state) => state.authData);
    const rawCookie = StateData?.SupportTicketDetails;
    const recaptcharef = useRef();

    useEffect(() => {
        ApiGetCallAuthKey(`/schools/by-number?schoolNumber=${schoolnumber}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setschoolname(responseRs.msg.name);
                setschoolid(responseRs.msg.id);
                setLoginFlag(responseRs.msg.sso);
                setGoogleMicrosoftFlag(responseRs.sso_type);
                if (responseRs?.msg?.helpdesk_updated_at != null) {
                    window.location.href = `/helpdesk-request/${schoolnumber}`
                }
                if (responseRs.msg.sso != 1) {
                    setallData({ ...allData, name: '', email: '', loginToken: '' })
                }
                getAllBuildings(setBuildings, responseRs.msg.id);
            }
        });
        TechMaintenceData(1);
        setTachDetails({ ...TachDetails, typeflag: 1 })
    }, []);

    function GetCookiesData() {
        if (rawCookie != undefined) {
            const decodedString = decodeURIComponent(rawCookie);
            const userDetailsForSupportTicket = JSON.parse(decodedString);
            setallData({ ...allData, name: userDetailsForSupportTicket.name, email: userDetailsForSupportTicket.email, loginToken: userDetailsForSupportTicket.ssoId })
        }
    }

    async function handleImageFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setError(validationMsg);
            setallData({ ...allData, Document: "", Filename: "" });
            e.target.value = '';
            return;
        }

        const compressedImage = await compressImage(file);
        const reader = new FileReader();
        reader.onload = function (event) {
            setallData({ ...allData, Document: compressedImage, Filename: compressedImage.name });
            setError('');
        };
        reader.readAsDataURL(compressedImage);
        e.target.value = '';
    }


    async function SaveSupportTicket() {


        var isFormValid = CheckValidation({ formID: 'SupportTicketForm' });
        var emailvalid = isValidEmail(allData.email);

        if (emailvalid == false) {
            setEmailValidation("Invalid Email")
            isFormValid = false;
        } else {
            setEmailValidation("");
        }

        if (allData.building == '' && allData.Buildingname == "") {
            setBuildingValidation("*required");
            isFormValid = false;
        } else {
            setBuildingValidation("");
        }
        if (!isFormValid) return;
        setLoading(true);
        const token = await recaptcharef.current.executeAsync();
        const formdata = new FormData();
        formdata.append('schoolId', schoolid);
        formdata.append('title', allData.title);
        formdata.append('name', allData.name);
        formdata.append('email', allData.email);
        formdata.append('roomId', allData.roomno == "other" ? 0 : allData.roomno);
        formdata.append('roomName', allData.roomname);
        if (allData.Document) {
            formdata.append('document', allData.Document);
        }
        formdata.append('description', allData.Description);
        formdata.append('studentNumber', allData.StudentNumber);
        formdata.append('flag', allData.Flag);
        formdata.append('captcha', token);
        formdata.append('typeFlag', TachDetails.typeflag);
        formdata.append('typeChildId', TechMaintenceSelected);
        formdata.append('buildingId', allData.building == "" ? 0 : allData.building);
        formdata.append('buildingName', allData.Buildingname);
        if (Video) {
            formdata.append('videos', Video);
        }

        ApiCmnHeadersPostCall(`/support-tickets/add-from-link`, formdata, false, true)
            .then(result => {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Ticket Created Successfully."} />);
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                        window.location.href = `/thankyou/${responseRs.supportTicketDetails.id}/${schoolnumber}/${responseRs.supportTicketDetails.supportTicketNum}/${responseRs.supportTicketDetails.ticketGuId}`
                    }, 2500);
                } else {
                    recaptcharef.current.reset();
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    async function TechMaintenceData(flag) {
        await ApiGetCallAuthKey(`/support-tickets/tech-maintenance-data?flag=${flag}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (flag == 1) {
                    setTachDetails({ ...TachDetails, Showoption: "", typeflag: 1, OtherFields: "d-none" });
                    setTechMainData(responseRs.technologies);
                } else {
                    setTachDetails({ ...TachDetails, Showoption: "", typeflag: 2, OtherFields: "d-none" });
                    setTechMainData(responseRs.maintenace);
                }
                setTechMaintenceSelected('');
            }
        });
    }
    function getRooms(buildingid) {
        ApiGetCallAuthKey(`/buildings?uuid=${buildingid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setRoomData(responseRs.msg?.room)
            }
        });
    }

    const handleReset = () => {
        setallData(prev => ({
            ...prev,
            title: "",
            name: (prev.loginToken || rawCookie) ? prev.name : "",
            email: (prev.loginToken || rawCookie) ? prev.email : "",
            building: "",
            roomno: "",
            Document: null,
            Filename: "",
            Description: "",
            Flag: 2,
            StudentNumber: '',
            Buildingname: '',
            roomname: ''
        }));
        setEmailValidation("");
        setBuildingValidation("");
        setIsCheckedForOther(false);
        setVideo('');
        setTechMaintenceSelected('');
        setRoomData([]);
        setError('');
        if (recaptcharef.current) {
            recaptcharef.current.reset();
        }
        const fileInput = document.getElementById('UploadFileId');
        if (fileInput) fileInput.value = '';

        let roleRadios = document.getElementsByName('role');
        if (roleRadios.length > 0) roleRadios[0].checked = true;

        let issueRadios = document.getElementsByName('Issuefacing');
        if (issueRadios.length > 0) issueRadios[0].checked = true;

        TechMaintenceData(1);
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    };

    return (
        <React.Fragment>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className="row">
                {LoginFlag == 0 ?
                    <div className="col-md-10 offset-md-1">
                        <div className="m-4 px-5">
                            <div className="GridBox m-auto mx-5">
                                <div className="col-12 py-4 text-center">
                                    {third_party_page_logo ?
                                        <img src={third_party_page_logo} className="img-fluid" alt="Logo" />
                                        :
                                        <img src="/images/LoginLogo.png" className="img-fluid" alt="Logo" />
                                    }
                                </div>
                                <div className='Header text-center'>
                                    <h5 className="mb-0">Create Support Ticket for <span className="schoolColorStatus">{schoolname}</span></h5>
                                    <img src='/images/supportTicketLine.svg' className='img-fluid ' />
                                </div>
                                <div className="row">
                                    <div className="col-md-6 font-15 text-center row py-3">
                                        <div className="col-12">
                                            <b className="font-15" style={{ color: "#495057" }}>
                                                {ticket_form_context_question}
                                            </b>
                                        </div>
                                        <div className="col-lg-10 offset-lg-1 text-center py-3">
                                            <div className='btns'>
                                                <label>
                                                    <input defaultChecked name='role' type='radio' onClick={(e) => {
                                                        setallData({
                                                            ...allData, Flag: 2, title: "", building: "", roomno: "",
                                                            Document: null, Filename: "", Description: "", StudentNumber: '',
                                                        })
                                                        setEmailValidation("");
                                                    }} />
                                                    <span className='btnnew firstnew'>{staff_member}</span>
                                                </label>
                                                <label>
                                                    <input name='role' type='radio' onClick={(e) => {
                                                        setallData({
                                                            ...allData, Flag: 1, title: "", building: "", roomno: "",
                                                            Document: null, Filename: "", Description: "", StudentNumber: ''
                                                        })
                                                        setEmailValidation("");
                                                    }} />
                                                    <span className='btnnew lastnew'>{manager_user}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 font-15 text-center row py-3">
                                        <div className="col-12">
                                            <b className="font-16" style={{ color: "#495057" }}>Choose based on the specific issue you are facing.</b>
                                        </div>
                                        <div className="col-lg-10 offset-lg-1 text-center py-3">
                                            <div className='btns'>
                                                <label>
                                                    <input defaultChecked name='Issuefacing' type='radio' onChange={(e) => { TechMaintenceData(1); }} />
                                                    <span className='btnnew firstnew'>Technology</span>
                                                </label>
                                                <label>
                                                    <input name='Issuefacing' type='radio' onChange={(e) => { TechMaintenceData(2); }} />
                                                    <span className='btnnew lastnew'>Maintenance</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div id='SupportTicketForm' className="parent">
                                    <div className='row'>
                                        <div className={`${TachDetails.Showoption}`}>
                                            <div className="col-12 px-4">
                                                <div className="col-12  py-2">
                                                    {TachDetails.typeflag == 1 ?
                                                        <b className="font-15" style={{ color: "#495057" }} >Choose Technology Options.</b>
                                                        :
                                                        <b className="font-15" style={{ color: "#495057" }}>Choose Maintenance Options.</b>
                                                    }
                                                </div>
                                                <div className="row px-4">
                                                    {TechMainData.map((item, i) => (
                                                        <div className="col-md-4 px-0 d-flex align-items-center list__item" key={item.id}>
                                                            <input type="radio" className="radio-btn" name="technology" itemid={item.id}
                                                                checked={TechMaintenceSelected === item.id}
                                                                id={`opt-${item.id}`} onChange={(e) => {
                                                                    setTechMaintenceSelected(item.id);
                                                                    setTachDetails({ ...TachDetails, OtherFields: "", Showoption: "" });
                                                                    GetCookiesData();
                                                                }} />
                                                            <label htmlFor={`opt-${item.id}`} className="label" style={{ color: '#4C5258' }}>
                                                                {item.name}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="align-items-center row py-2 px-4">
                                                <b className="font-15" style={{ color: "#495057" }}>
                                                    Do you know issue is related to which Building?</b>
                                            </div>
                                            <div>
                                                <div className='col-12 py-2 px-4'>
                                                    <div className="row">
                                                        {Buildings.map((item, i) => {
                                                            return <div className="col-md-4 py-2 d-flex align-items-start text-break">
                                                                <input type="radio" className="form-check-input me-2" checked={allData.building === item.id}
                                                                    onChange={(e) => {
                                                                        setallData({ ...allData, building: item.id, roomno: 0, roomname: "" });
                                                                        setIsCheckedForOther(false); getRooms(item.id)
                                                                    }} name="supportticketbuilding"
                                                                />
                                                                {item.name}
                                                            </div>
                                                        })}
                                                        <div className="col-md-4 py-2">
                                                            <input type="radio" className="form-check-input me-2" name="supportticketbuilding"
                                                                checked={isCheckedForOther} onChange={(e) => {
                                                                    setIsCheckedForOther(e.target.checked); setallData({ ...allData, building: "", roomno: 0, roomname: "" });
                                                                    setRoomData([])
                                                                }}
                                                            />
                                                            Other
                                                        </div>
                                                        {isCheckedForOther == true && (
                                                            <div className='col-4'>
                                                                <input type="text" placeholder="Enter Building*" required autoComplete='off' name='building' className="form-control" value={allData.Buildingname} onChange={(e) => setallData({ ...allData, Buildingname: e.target.value })} />
                                                                <span className="form-text invalid-feedback">
                                                                    *required
                                                                </span>
                                                            </div>
                                                        )}
                                                        {!isCheckedForOther && <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{BuildingValidation}</span>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className={`row px-4 ${TachDetails.OtherFields}`}>
                                        <div className='col-md-4 py-3'>
                                            <div className='col-12'>
                                                <input type="text" placeholder="Name*" autoComplete='off' name='name' className="form-control" required value={allData.name} onChange={(e) => setallData({ ...allData, name: e.target.value })} />
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-md-4 py-3'>
                                            <div className='col-12'>
                                                <input type="email" placeholder="Email*" autoComplete='off' name='email' className="form-control" value={allData.email} onChange={(e) => setallData({ ...allData, email: e.target.value })} />
                                                <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{EmailValidation}</span>
                                            </div>
                                        </div>
                                        {allData.Flag == 2 && (
                                            <>
                                                <div className='col-md-4 py-3'>
                                                    <div className='col-12'>
                                                        <select value={allData.roomno} onChange={(e) => {
                                                            setallData({ ...allData, roomno: e.target.value, roomname: '' });
                                                        }}>
                                                            <option value="0">Select Room</option>
                                                            {RoomData?.length &&
                                                                RoomData?.map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.name}</option>
                                                                })
                                                            }
                                                            <option value="other">Other</option>

                                                        </select>

                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {allData.roomno == "other" && (
                                            <div className='col-4 py-3'>
                                                <input type="text" placeholder="Enter Room" required autoComplete='off' name='roomname' className="form-control"
                                                    value={allData.roomname} onChange={(e) => setallData({ ...allData, roomname: e.target.value })} />
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        )}
                                        <div className='col-md-4 py-3'>
                                            <div className='col-12'>
                                                {allData.Flag != 1 ?
                                                    <input type="text" placeholder={user_no} autoComplete='off' name='roomno' className="form-control" value={allData.StudentNumber} onChange={(e) => setallData({ ...allData, StudentNumber: e.target.value.toUpperCase() })} />
                                                    :
                                                    <>
                                                        <input type="text" placeholder={user_no + '*'} required autoComplete='off' name='roomno' className="form-control" value={allData.StudentNumber} onChange={(e) => setallData({ ...allData, StudentNumber: e.target.value.toUpperCase() })} />
                                                        <span className="form-text invalid-feedback">
                                                            *required
                                                        </span>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <div className='col-md-4 py-3'>
                                            <div className='col-12'>
                                                <input type="textarea" placeholder="Ticket Subject *" autoComplete='off' name='title' className="form-control" required value={allData.title} onChange={(e) => setallData({ ...allData, title: e.target.value })} />
                                                <span className="form-text invalid-feedback">
                                                    *required
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-md-4 py-3'>
                                            <input type="file" label="img" id="UploadFileId" name="myFile" accept=".jpg,.png,.jpeg" onChange={(e) => handleImageFileUpload(e)} />
                                            <label className="supportTicketbtn col-md-12 cursor-pointer" htmlFor="UploadFileId" style={{ color: "#909091" }}>
                                                Choose File (Attach Image)
                                            </label>
                                            {allData.Filename && <label className="ps-2 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{allData.Filename} </label>}
                                            {error && <div className="ps-2 mt-1 redText">{error}</div>}

                                        </div>
                                        <VideoUpload selectedFile={(e) => setVideo(e)} />
                                        <div className="col-md-8 pb-3">
                                            <textarea placeholder="Ticket Description" type="textarea" rows={3} autoComplete="off" name="RepairedNm" className="form-control" value={allData.Description} onChange={(e) => setallData({ ...allData, Description: e.target.value })} />
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <ReCAPTCHA ref={recaptcharef} sitekey={captchasitekey} size="invisible" />
                                        </div>
                                        <div className="col-md-12 text-center mt-2 py-3 justify-content-center align-items-center">
                                            <button className="SaveBtn mt-2" onClick={(e) => SaveSupportTicket(e)}>Submit Ticket</button>
                                            <label className="ms-2 cursor-pointer" onClick={handleReset}> <u>Reset</u></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    LoginFlag == 1 ?
                        GoogleMicrosoftFlag == 1 ?
                            <>
                                <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
                                <div className="position-relative MainDiv">
                                    <GoogleLoginForSupportTicket flag="supportticket" setLoginFlag={setLoginFlag} setallData={setallData} allData={allData} />
                                </div>
                            </>
                            :
                            <>
                                <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
                                <div className="position-relative MainDiv">
                                    <MicrosoftLoginForSupportTicket flag="supportticket" setLoginFlag={setLoginFlag} />
                                </div>
                            </>
                        :
                        <></>
                }
            </div >
        </React.Fragment>
    )
}
